<template >
  <div class="RoomQuantity" v-if="show">
    <h2>{{ tran("ROOM_QUANTITY_TITLE") }}</h2>
    <p>{{ tran("ROOM_QUANTITY_DESC", {maxGuest: run('get', 'config.maxGuest')}) }}</p>
    <div class="">
      <InputPlusField
        :required="true"
        v-model="data.numberOfRoom"
        :min="run('get', 'config.minRoom')"
        :max="run('get', 'config.maxRoom')"
        class="number-of-rooms input-increase"
      />
    </div>
    <div class="buttons">
      <button
        id="room-no-click"
        type="button"
        class="btn btn-success"
        :disabled="!run('validate')"
        @click.prevent="run('next')"
      >
        {{ tran("SELECT_CONTINUE") }}
      </button>
    </div>
    <div class="room-warning" v-html="run('get', 'ship.roomWarning')"></div>
  </div>
</template>

<script>
import InputPlusField from "./InputPlusField.vue";
export default {
  name: "RoomQuantity",
  components: { InputPlusField },
  props: {
    run: Function,
  },
  data: function () {
    return {};
  },
  mounted: function () {
    this.run("set", "groupStep." + this.$.type.name, "select_room");
  },
  watch: {
    show: function (n) {
      if (n) {
        this.onShow();
      } else {
        this.onHide();
      }
    },
  },

  computed: {
    show: function () {
      return this.run("currentStep") == this.$.type.name;
    },
    data() {
      return this.run("get", "data");
    },
  },
  methods: {
    tran: function (key, replaces) {
      return this.run("tran", key, replaces);
    },
    onShow: function () {},
    onHide: function () {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
